import React from "react";
import "./App.scss";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Nav from "./components/Nav";
import Home from "./components/Home";
import About from "./components/About";
import Skills from './components/Skills'
import Experience from "./components/Experience";
import MySites from "./components/MySites";
import Goals from "./components/Goals";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Nav />
        <Switch>
          <Route exact path="/">
            <Home />
            <About />
            <Skills />
            <Experience />
            <MySites />
            <Goals />
            <Footer />
          </Route>
          <Route exact path="/about"><About/></Route>
          <Route path="/skills"><Skills /></Route>
          <Route path="/experience"><Experience /></Route>
          <Route path="/sites"><MySites /></Route>
          <Route path="/goals"><Goals /></Route>
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
